var map = {
	"./diemitte-positiv.svg": 103,
	"./diemitte.svg": 896,
	"./fdp-positiv.svg": 374,
	"./fdp.svg": 93,
	"./glp-positiv.svg": 67,
	"./glp.svg": 884,
	"./gruene-positiv.svg": 120,
	"./gruene.svg": 883,
	"./sp-positiv.svg": 315,
	"./sp.svg": 412,
	"./svp-positiv.svg": 673,
	"./svp.svg": 710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;